import { CommonModule } from "@angular/common";
import { Component, OnDestroy, ViewChild, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IonContent, IonicModule } from "@ionic/angular";

import { Router } from "@angular/router";
import { CodereNavbar } from "@components/common/codere-navbar/codere-navbar";
import { GlobalVarsModel } from "@models/ModelGlobalsVar";
import { TranslateModule } from "@ngx-translate/core";
import { EventsService } from "@providers/EventsService";
import { TrackingService } from "@providers/TrackingService";
import { UserService } from "@providers/UserService";
import { NewBaseService } from "@providers/newBase.service";
import { DeviceService } from "@services/device.service";
import { PAGES_PATHS } from "@shared-constants/routes";
import { CodereFooterComponent } from "@shared-mso-components/footer/codere-footer/codere-footer";
import { UserSectionTitle } from "@shared-mso-components/user-section-title/user-section-title";
import { Utils } from "@sports-utils/Utils";
import { Subject, of, switchMap, takeUntil } from "rxjs";

@Component({
  selector: "page-cuota-change",
  templateUrl: "./cuota-change.page.html",
  standalone: true,
  imports: [
    IonicModule,
    CommonModule,
    FormsModule,
    TranslateModule,
    CodereFooterComponent,
    UserSectionTitle,
    CodereNavbar,
  ],
})
export class CuotaChangePage implements OnDestroy {
  @ViewChild(IonContent) content: IonContent;
  selectedCuotaChange: any;
  firstEnter: boolean = true;
  public trackEvent: TrackEvent;

  globalVars: GlobalVarsModel;
  utils = inject(Utils);
  userService = inject(UserService);
  trackingService = inject(TrackingService);
  eventService = inject(EventsService);
  router = inject(Router);
  deviceService = inject(DeviceService);
  newBaseService = inject(NewBaseService);

  isMobile = false;
  isDesktop = false;

  private readonly unsubscribe$ = new Subject();

  constructor() {
    this.newBaseService.getVars
      .pipe(
        switchMap((data: GlobalVarsModel) => {
          this.globalVars = data;
          return of(null);
        }),
      )
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(() => {
        this.selectedCuotaChange = this.globalVars.cuotaAccept;
      });

    this.isDesktop = this.deviceService.isDesktop();
    this.isMobile = this.deviceService.isMobile();
  }

  ionViewWillEnter() {
    this.trackingService.trackEvent(["AccessToOddType", "", "", "Acceder tipo de cuota", "event"]);
    this.eventService.publish("footer:refresh", this.content); // **+** La navegación se hará utilizando el routing de angular
  }

  changeCuotaAccept() {
    //change language
    if (!this.firstEnter) {
      this.utils.setCuotaAccept(this.selectedCuotaChange);
      if (this.globalVars.user.logged) {
        this.userService.updateCustomizations(this.globalVars.user.customization).subscribe(
          (data: any) => {
            this.router.navigate([PAGES_PATHS.BASE], {});
          },
          (err: any) => {},
        );
      }
    }
    this.firstEnter = false;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }
}
